import type { Theme } from '@src/app/themes';
import type { ButtonProps } from '@src/shared/ui/Button';
import { Button } from '@src/shared/ui/Button';
import { forwardRef } from 'react';

const StyleShet = {
  button: (active: boolean) => (theme: Theme) => ({
    border: '1px solid',
    borderColor: theme.palette.grey[600],
    color: active ? theme.palette.red[600] : theme.palette.grey[800],
    width: '92px',
  }),
};

type TodayButtonProps = ButtonProps & { active: boolean };
const TodayButton = forwardRef<HTMLButtonElement, TodayButtonProps>(
  (props, ref) => {
    const { active, ...rest } = props;
    return (
      <Button
        ref={ref}
        {...rest}
        variant="outlined"
        sx={StyleShet.button(active)}
      >
        Today
      </Button>
    );
  },
);

export default TodayButton;
